module.exports = __webpack_public_path__ + "img/電気回路_6_9.81eabbc4.png";